export const API_BASE_URL = 'http://test-api.memss.co.uk/';
export const LOGIN = 'Token';